import * as utils from '@libs/utils'
import * as backend from '@libs/backend'
import * as moment from 'moment'
import * as chatworkMessage from '@libs/chatworkMessage'
import * as taskRequestManager from '@managers/taskRequestManager'

const REQUESTPOST_TASKS_TYPE = 'apollo_request_post'
const ORDER_TASKS_TYPE = 'order'
// 社員面接のチャットルームID
const INTERVIEWS_ROOMID_TASKS_TYPE = 'interviews_chatwork_master'

// 本日日付
const today = moment().format('YYYY-MM-DD')

export const RequestPostSchema = {
  category2: [],
  category: [],
  requestNo: '',
  lastRequestNo: '',
  clientName: '',
  clientDepartmentName: '',
  clientAddress: '',
  clientAddress2:'',
  clientPersonName: '',
  clientMail: '',
  inquiry_title: '',
  note: '',
  commonFile: {},
  addFileBtn: [],
  commonFile2: {},
  commonFile3: {},
  commonFile4: {},
  commonFile5: {},
  reason_note: '',
  toDepartment: '',
  toDepartmentId: '',
  toStaffName: '',
  toStaffId: '',
  byUser: '',
  byUserId: '',
  requestDate: '',
  kubunLimit: 1,
  limitDate: '',
  newNowFlag: [],
  newClass: [],
  estimationCategory: [],
  estimationCleanCategory: [],
  estimationInspectCategory: [],
  estimationOtherCategory: [],
  buildingName: '',
  siteCode: '',
  stairs: '',
  basement: '',
  households: '',
  estimationReason: '',
  availablePowerFlag: [],
  parkingFlag: [],
  availableToiletFlag: [],
  apartmentType: [],
  estimationRoundLabel: '',
  cleanCount: [],
  dustRemoval: [],
  dustCount: [],
  rlsToiletCleaning: [],
  rlsToiletTimes: '',
  rlsToiletPlace: '',
  estimationRoundPlusLabel: '',
  plusCleanCount: [],
  plusDustRemoval: [],
  plusDustCount: [],
  plusToiletCleaning: [],
  plusToiletCleaningNormal: [],
  plusToiletTimes: '',
  plusToiletTimesNormal: '',
  plusToiletPlace: '',
  plusToiletPlaceNormal: '',
  residenceType: [],
  estimationEverydayLabel: '',
  everydayCleans: [],
  managerWorkLabel: '',
  managerWorks: [],
  regularCleanLabel: '',
  regularCleans: [],
  regularCleanImage: {},
  regularCleanImage2: {},
  regularCleanImage3: {},
  regularCleanWorkWay: '',
  glassCleanLabel: '',
  glassCleanCount: '',
  glassCleanImage: {},
  glassCleanImage2: {},
  glassCleanImage3: {},
  glassCleanWorkWay: [],
  plantingCount: '',
  plantingPlaceFile: {},
  plantingPlaceFile2: {},
  plantingPlaceFile3: {},
  plantingReportFile: {},
  plantingReportFile2: {},
  plantingReportFile3: {},
  specialCleans: [],
  specialCleanImage: {},
  specialCleanImage2: {},
  specialCleanImage3: {},
  roundSubs: [],
  fireInspectReport: {},
  fireInspectReport2: {},
  fireInspectReport3: {},
  pressPumpInspectReport: {},
  pressPumpInspectReport2: {},
  pressPumpInspectReport3: {},
  constructionEquipmentInspectReport: {},
  constructionEquipmentInspectReport2: {},
  constructionEquipmentInspectReport3: {},
  specificInspectReport: {},
  specificInspectReport2: {},
  specificInspectReport3: {},
  waterTankCapacity: '',
  elevatedWaterTankFlag: '',
  waterQualityInspectFlag: '',
  waterPompInspectFlag: '',
  waterTankReport: {},
  waterTankReport2: {},
  waterTankReport3: {},
  dorainPipeCleanCount: '',
  dorainPipeAge: '',
  dorainPipeCleanResults: '',
  dorainPipeHolidyFlag: '',
  dorainPipeMultiFlag: '',
  commonAreaInspectCount: '',
  commonAreaReport: {},
  commonAreaReport2: {},
  commonAreaReport3: {},
  evInspectContent: [],
  evInspectFile: {},
  evInspectFile2: {},
  evInspectFile3: {},
  evInspectMaker: '',
  evInspectMakeYear: '',
  evQty: '',
  evUnitName: '',
  createDate: '',
  postalCode: '',
  state: '',
  city: '',
  street: '',
  building: '',
  otherWorks: [],
  roundServiceMemo: '',
  roundPlusMemo: '',
  everydayCleanMemo: '',
  managerWorkMemo: '',
  regularCleanMemo: '',
  glassCleanMemo: '',
  estimationDorainPipeMemo: '',
  estimationWaterTankMemo: '',
  plantingMemo: '',
  specialCleanMemo: '',
  roundSubMemo: '',
  estimationMRSMemo: '',
  temporarySaveFlag: false,
  orderNo: '',
  telephoneNumber: '',
  dentatsuCategory: [],
  notNewEnter: true,
  mail: {},
  employeeName: '',
  employmentClass: [],
  employmentName: '',
  employmentKana: '',
  employmentStaffNumber: '',
  // 再入社のとき、選んだ退職者の以前の社員番号と前回の退職の内容（表示用。清掃員を選んだときに AKBS の清掃員マスタから入れる）
  beforeStaffCd: '',
  // employmentBirthDay: '',
  // employmentAge: '',
  // employmentSex: [],
  // employmentPostCode: '',
  // employmentAddress1: '',
  // employmentAddress2: '',
  // employmentTel: '',
  // employmentMobile: '',
  // employmentEmergency: [{}],
  // cutoffDate: null,

// スマイル移行後（古い面接がなくなったら）、けしてOK
  // employmentTrainType: [],
  // employmentTrainExpenses: '',
  // employmentBusType: [],
  // employmentBusExpenses: '',
  // employmentParkingType: [],
  // employmentParkingExpenses: '',
  // employmentEmergencyContactKana: '',
  // employmentEmergencyContact: '',
  // employmentEmergencyAddress: '',
  // employmentEmergencyPhoneNumber: '',
  // employmentEmergencyRelationship: '',
  // employmentHourlyWage: '',
  
  // employmentWorkTask: [],
  // employmentHolidayType: [],
  // employmentTrashRemoval: [],
  // employmentAppliedWork: [{
  // }],
  // employmentFamilyMembers: [],
  // employmentCustomer: '',
  // employmentClosingDate: [],
  // employmentArea: {},
// スマイル移行後、けしてOKここまで



  // clientFax: '',
  // employmentBuildingName: '',
  // employmentSiteCode: '',
  // employmentSiteAddress: '',
  // employmentChangedDate: '',
  employmentHireDate: '',
  // employmentRetirementDate: '',
  employmentMaterial: [],
  employmentDocument: {},
  employmentRemarks:'',
  employmentRegularStaff: false,  // 社員フラグ
  employmentDepartment: '',
  employmentDepartmentId: [],
  employmentCompanion: '',
  employmentWeekly: [],
  employmentPublicHoliday: [],
  employmentMoving: '',
  employmentParkingCorporation: [],
  employmentParkingPrivate: [],
  employmentCostPrivate: '',
  employmentMail: '',
  employmentMailDomain: '',
  employmentMedium: '',
  employmentParkingStatus: [],
  employmentContract: [],
  // otherChangeItemsName: [],
  // otherChangeItemsKey: [],

  // interviewsInputDay: '',
  // interviewsKana: '',
  interviewsName: '',
  // interviewsPostCode: '',
  // interviewsAddress1: '',
  // interviewsAddress2: '',
  // interviewsTel: '',
  // interviewsMobile: '',
  // interviewsSex: [],
  // interviewsBirthDay: '',
  // interviewsAge: '',
  // interviewsNearestStationFromHome: '',
  interviewsMedium: '',
  // familyMembers:[{
  //     relationship: '',
  //     name: '',
  //     address:'',
  //     phoneNumber: ''
  //   }],
  // 配列に変更
  // emergency: [{}],
  // hourlyWage: '',
  interviewsAppliedWorkLocationAddress: null,
  // interviewsSiteCode: '',
  // interviewsSiteAddress: '',
  
  // cdContentsWork: null,
  // cdKubunHoliday: null,
  // hasCarryingoutGarbage: null,
  // hasExportingCompanysHoliday: null,
  
  area: '',
  
  // kubunTrain: null,
  // fareTrain: '',
  // kubunBus: null,
  // fareBus: '',
  // kubunBicycleParking: null,
  // fareBicycleParking: '',

  // appliedWork:[{
  //   cdContentsWork: null,
  //   cdKubunHoliday: null,
  //   hasExportingCompanysHoliday: null,
  //   hasCarryingoutGarbage: null
  // }],
  interviewsMaterial: [],
  interviewsCognitiveRes: {},
  interviewsDocument: {},
  interviewsInterviewNotes: '',
  interviewsResult: [],
  interviewsCommonFileList: [1],
  interviewsRegularStaff: false, // 社員フラグ,
  interviewsDate: '',
  interviewsDepartmentId: [],

  clientLists: []
}

/**
 * 添付ファイル項目の初期値
 */
export const AttachmentSchema = {
  originalName: '',
  url: '',
  content: ''
}

/**
 *  リクエストポスト 取得
 */
export async function getRequestPost(context, _id) {
  const searchCondition = {
    searchCondition: {
      type: REQUESTPOST_TASKS_TYPE,
      _id
    }
  }
  try {
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const allocation = responseData[0] || null
    return allocation
  } catch (error) {
    console.log('getRequestPost error !!!')
    console.log(error)
    return null
  }
}

/**
 * リクエストポスト _id 取得
 * @param {*} context
 * @param {*} _id
 * @returns
 */

export async function getRequest(context, _id) {
  const searchCondition = {
    searchCondition: {
      type: REQUESTPOST_TASKS_TYPE,
      _id
    }
  }
  try {
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const allocation = responseData[0] || null
    return allocation
  } catch (error) {
    console.log('getRequest error !!!')
    console.log(error)
    return null
  }
}

/**
 * 雇い入れ用面接関連 取得
 * @returns
 */
export async function getInterviersForEmployment(context, requestNo, interviewsName, clientName, toStaffName, interviewsResult) {

  const searchCondition = {
    searchCondition: {
      status: { $ne: "remove" },
      type: REQUESTPOST_TASKS_TYPE,
      category: '面接関連',
      interviewsResult,
      isEmployment: { $ne: true }
    },
    sort: {
      requestNo: -1
    }
  }

  // お問い合わせ番号 条件指定
  if (requestNo && requestNo.length > 0) searchCondition.searchCondition['requestNo'] = { $regex: requestNo, $options: 'i'}

  // 面接者名 条件指定
  if (interviewsName && interviewsName.length > 0) searchCondition.searchCondition['interviewsName'] = { $regex: interviewsName, $options: 'i'}

  // 得意先名 条件指定
  if (clientName && clientName.length > 0) searchCondition.searchCondition['clientName'] = { $regex: clientName, $options: 'i'}

  // 担当者 条件指定
  if (toStaffName && toStaffName.length > 0) searchCondition.searchCondition['toStaffName'] = { $regex: toStaffName, $options: 'i'}

  try {
    // console.log(searchCondition)
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const interviewsData = responseData || []
    interviewsData.forEach((e) => {
      if (e.totalAmount == '') {
        e.totalAmount = '0'
      }
    })
    return interviewsData
  } catch (error) {
    console.log('getInterviewsForEmployment error !!!')
    console.log(error)
    return []
  }
}

/**
 * リクエストポスト 登録
 */
export async function register(context, rp, cwCooperation) {
  try {
	// お問い合わせ番号採番（お問い合わせNoがないもの）
	if (!rp.requestNo) {
      const no = await createNo(context, rp)
      rp.requestNo = no
    }

    const registrationData = createRegistrationData(rp)
    // console.log('registrationData : ')
    // console.log(registrationData)

    const q = {}
    if (cwCooperation === true) {
      q.cwCooperation = 'cw-on'
    } else if (cwCooperation === false) {
      q.cwCooperation = 'cw-off'
    }

    const result = await context.$pigeon.registerTask(REQUESTPOST_TASKS_TYPE, registrationData, q)

    // 面接（清掃員）・雇い入れ（清掃員）は、AKBS の申請（req_akbs）に空の枠を作る
    await createAkbsShell(rp, result._id)

    return { id: result._id, requestNo: rp.requestNo }
  } catch (error) {
    console.log('register error !!!')
    console.log(error)
    return false
  }
}

/**
 * AKBS の申請（req_akbs）に空の枠を作る（面接（清掃員）・雇い入れ（清掃員）のメインタスクを登録したとき）
 * API: akbsInputForm/createShell
 * 申請の中身は入れず、紐づけ・清掃員名・状況「未保存」だけ。申請一覧に出るので、作っただけで誰も入力していない申請に気づける
 * 新規入社の雇い入れは面接の id（interviewsId）を持っているので、バックが面接の行につなげる（同じ人が2行にならない）
 * 枠が作れなくてもメインタスクの登録は止めない（入力画面で最初に保存したときに行ができる）
 * @param {*} rp メインタスク
 * @param {*} id 登録したメインタスクの _id
 */
async function createAkbsShell(rp, id) {
  const cat = (rp.category && rp.category[0]) || ''
  let data = null
  if (cat == '雇い入れ（清掃員）') {
    // requestNo：雇い入れメインタスクの問い合わせNo（申請一覧などで、メインタスクを引かずに No を出すために控える。面接の No は持たない）
    // contractFormId：契約詳細入力画面から作った雇い入れなら、その契約詳細の申請の id（registerEmploymentFromContract が入れている）
    data = {
      interviewsId: rp.interviewsId || '',
      employmentId: id,
      staff: rp.employmentName || '',
      staffDailyCleaning: rp.employmentStaffNumber || '',
      requestNo: rp.requestNo || '',
      contractFormId: rp.akbsContractFormId || ''
    }
  } else if (cat == '面接関連' && !rp.interviewsRegularStaff) {
    data = { interviewsId: id, employmentId: '', staff: rp.interviewsName || '', staffDailyCleaning: '' }
  }
  if (!data || !id) {
    return
  }
  try {
    await backend.postData('akbsInputForm/createShell', data)
  } catch (error) {
    console.log('createAkbsShell error !!!')
    console.log(error)
  }
}

/**
 * 更新
 * @param {*} context
 * @param {*} rp
 * @param {*} cwCooperation
 * @returns
 */
export async function update(context, rp, cwCooperation) {
  try {
    if (!rp.createDate) {
      rp.createDate = moment().format('YYYY-MM-DD HH:mm:ss')
    }
    const registrationData = createRegistrationData(rp)
    registrationData.type = REQUESTPOST_TASKS_TYPE
    // console.log('registrationData : ')
    // console.log(registrationData)

    const q = {}
    if (cwCooperation === true) {
      q.cwCooperation = 'cw-on'
    } else if (cwCooperation === false) {
      q.cwCooperation = 'cw-off'
    }

    await context.$pigeon.updateTask(registrationData._id, registrationData, q)

    return { id: registrationData._id, requestNo: registrationData.requestNo }
  } catch (error) {
    console.log('update error !!!')
    console.log(error)
    return false
  }
}

/**
 * 新規リクエストポスト生成
 * @returns
 */
export function create() {
  const limitDate = utils.getToday()
  const requestDate = utils.getToday()
  const newRequestPost = { ...utils.clone(RequestPostSchema), limitDate, requestDate }

  newRequestPost.commonFile = createEmptyAttachment()
  newRequestPost.commonFile2 = createEmptyAttachment()
  newRequestPost.commonFile3 = createEmptyAttachment()
  newRequestPost.commonFile4 = createEmptyAttachment()
  newRequestPost.commonFile5 = createEmptyAttachment()
  newRequestPost.regularCleanImage = createEmptyAttachment()
  newRequestPost.regularCleanImage2 = createEmptyAttachment()
  newRequestPost.regularCleanImage3 = createEmptyAttachment()
  newRequestPost.glassCleanImage = createEmptyAttachment()
  newRequestPost.glassCleanImage2 = createEmptyAttachment()
  newRequestPost.glassCleanImage3 = createEmptyAttachment()
  newRequestPost.plantingPlaceFile = createEmptyAttachment()
  newRequestPost.plantingPlaceFile2 = createEmptyAttachment()
  newRequestPost.plantingPlaceFile3 = createEmptyAttachment()
  newRequestPost.plantingReportFile = createEmptyAttachment()
  newRequestPost.plantingReportFile2 = createEmptyAttachment()
  newRequestPost.plantingReportFile3 = createEmptyAttachment()
  newRequestPost.specialCleanImage = createEmptyAttachment()
  newRequestPost.specialCleanImage2 = createEmptyAttachment()
  newRequestPost.specialCleanImage3 = createEmptyAttachment()
  newRequestPost.fireInspectReport = createEmptyAttachment()
  newRequestPost.fireInspectReport2 = createEmptyAttachment()
  newRequestPost.fireInspectReport3 = createEmptyAttachment()
  newRequestPost.pressPumpInspectReport = createEmptyAttachment()
  newRequestPost.pressPumpInspectReport2 = createEmptyAttachment()
  newRequestPost.pressPumpInspectReport3 = createEmptyAttachment()
  newRequestPost.constructionEquipmentInspectReport = createEmptyAttachment()
  newRequestPost.constructionEquipmentInspectReport2 = createEmptyAttachment()
  newRequestPost.constructionEquipmentInspectReport3 = createEmptyAttachment()
  newRequestPost.specificInspectReport = createEmptyAttachment()
  newRequestPost.specificInspectReport2 = createEmptyAttachment()
  newRequestPost.specificInspectReport3 = createEmptyAttachment()
  newRequestPost.waterTankReport = createEmptyAttachment()
  newRequestPost.waterTankReport2 = createEmptyAttachment()
  newRequestPost.waterTankReport3 = createEmptyAttachment()
  newRequestPost.commonAreaReport = createEmptyAttachment()
  newRequestPost.commonAreaReport2 = createEmptyAttachment()
  newRequestPost.commonAreaReport3 = createEmptyAttachment()
  newRequestPost.evInspectFile = createEmptyAttachment()
  newRequestPost.evInspectFile2 = createEmptyAttachment()
  newRequestPost.evInspectFile3 = createEmptyAttachment()
  newRequestPost.employmentDocument = createEmptyAttachment()
  newRequestPost.interviewsCognitiveRes = createEmptyAttachment()
  newRequestPost.interviewsDocument = createEmptyAttachment()

  return newRequestPost
}

/**
 * 空の添付ファイル項目 生成
 * @returns
 */
export function createEmptyAttachment() {
  const emptyAttachmen = utils.clone(AttachmentSchema) // { ...EstimateAttachmentSchema }
  return emptyAttachmen
}

// /**
//  * 更新
//  * @param {*} context
//  * @param {*} orgRp
//  * @param {*} rp
//  * @returns
//  */
// export async function updateDispatchDate(context, orgRp, rp) {

//   if (!orgRp._id) {
//     console.log('IDが指定されていません。')
//     return false
//   }

//   const updateData = {
//     type: REQUESTPOST_TASKS_TYPE,
//     rp
//   }

//   try {
//     await context.$pigeon.updateTask(orgRp._id, updateData, {})
//     return true
//   } catch (error) {
//     console.log('updateLeasePeriod error !!!')
//     console.log(error)
//     return false
//   }
// }

/**
 * No 生成
 */
async function createNo(context, rp) {
  const res = await context.$pigeon.getAutomaticNumber(
    REQUESTPOST_TASKS_TYPE,
    'requestNo',
    'apollo_request_no_setting',
    rp
  )
  return res
}


/**
 * 添付ファイルデータ 生成
 */
function createAttachmentRegistrationData(registrationData, targetAttachmentName) {
  if (registrationData[targetAttachmentName]) {
    registrationData[`${targetAttachmentName}_file_content`] = registrationData[targetAttachmentName].content || ''
    registrationData[`${targetAttachmentName}_file_name`] = registrationData[targetAttachmentName].originalName || ''
    registrationData[`${targetAttachmentName}_display_file_name`] = registrationData[targetAttachmentName].originalName || ''
  } else {
    registrationData[`${targetAttachmentName}_file_content`] = ''
    registrationData[`${targetAttachmentName}_file_name`] = ''
    registrationData[`${targetAttachmentName}_display_file_name`] = ''
  }
  delete registrationData[targetAttachmentName]
}

/**
 * 登録データ 生成
 */
function createRegistrationData(rp) {
  const registrationData = utils.clone(rp)

  // 添付ファイル項目設定
  createAttachmentRegistrationData(registrationData, 'commonFile')
  createAttachmentRegistrationData(registrationData, 'commonFile2')
  createAttachmentRegistrationData(registrationData, 'commonFile3')
  createAttachmentRegistrationData(registrationData, 'commonFile4')
  createAttachmentRegistrationData(registrationData, 'commonFile5')
  createAttachmentRegistrationData(registrationData, 'regularCleanImage')
  createAttachmentRegistrationData(registrationData, 'regularCleanImage2')
  createAttachmentRegistrationData(registrationData, 'regularCleanImage3')
  createAttachmentRegistrationData(registrationData, 'glassCleanImage')
  createAttachmentRegistrationData(registrationData, 'glassCleanImage2')
  createAttachmentRegistrationData(registrationData, 'glassCleanImage3')
  createAttachmentRegistrationData(registrationData, 'plantingPlaceFile')
  createAttachmentRegistrationData(registrationData, 'plantingPlaceFile2')
  createAttachmentRegistrationData(registrationData, 'plantingPlaceFile3')
  createAttachmentRegistrationData(registrationData, 'plantingReportFile')
  createAttachmentRegistrationData(registrationData, 'plantingReportFile2')
  createAttachmentRegistrationData(registrationData, 'plantingReportFile3')
  createAttachmentRegistrationData(registrationData, 'specialCleanImage')
  createAttachmentRegistrationData(registrationData, 'specialCleanImage2')
  createAttachmentRegistrationData(registrationData, 'specialCleanImage3')
  createAttachmentRegistrationData(registrationData, 'fireInspectReport')
  createAttachmentRegistrationData(registrationData, 'fireInspectReport2')
  createAttachmentRegistrationData(registrationData, 'fireInspectReport3')
  createAttachmentRegistrationData(registrationData, 'pressPumpInspectReport')
  createAttachmentRegistrationData(registrationData, 'pressPumpInspectReport2')
  createAttachmentRegistrationData(registrationData, 'pressPumpInspectReport3')
  createAttachmentRegistrationData(registrationData, 'constructionEquipmentInspectReport')
  createAttachmentRegistrationData(registrationData, 'constructionEquipmentInspectReport2')
  createAttachmentRegistrationData(registrationData, 'constructionEquipmentInspectReport3')
  createAttachmentRegistrationData(registrationData, 'specificInspectReport')
  createAttachmentRegistrationData(registrationData, 'specificInspectReport2')
  createAttachmentRegistrationData(registrationData, 'specificInspectReport3')
  createAttachmentRegistrationData(registrationData, 'waterTankReport')
  createAttachmentRegistrationData(registrationData, 'waterTankReport2')
  createAttachmentRegistrationData(registrationData, 'waterTankReport3')
  createAttachmentRegistrationData(registrationData, 'commonAreaReport')
  createAttachmentRegistrationData(registrationData, 'commonAreaReport2')
  createAttachmentRegistrationData(registrationData, 'commonAreaReport3')
  createAttachmentRegistrationData(registrationData, 'evInspectFile')
  createAttachmentRegistrationData(registrationData, 'evInspectFile2')
  createAttachmentRegistrationData(registrationData, 'evInspectFile3')
  createAttachmentRegistrationData(registrationData, 'interviewsCognitiveRes')
  createAttachmentRegistrationData(registrationData, 'interviewsDocument')
  if (!registrationData.employmentDocument_display_file_name) {
    createAttachmentRegistrationData(registrationData, 'employmentDocument')
  }

  return registrationData
}

/**
 * リクエストポスト一覧取得
 * @param {*} context
 * @param {*} searchKeys キーワード検索対象項目
 * @param {*} btn ボタン検索
 * @param {*} toggle トグル検索
 * @param {*} text 文字列検索
 * @param {*} userName ログインユーザー名
 * @param {*} userNameWithKana ログインユーザー名カナつき
 * @param {*} userId ログインユーザーID
 * @param {*} group4 G4以上
 * @param {*} admin 管理者権限
 * @param {*} regularStaffAuth 正社員面接権限
 * @param {*} manager 人事経理総務
 * @param {*} mainDepartment メイン部署
 * @param {*} dualPositionNames 兼任部署含む所属部署名
 * @param {*} dualPositionIds 兼任部署含む所属部署ID
 * @param {*} next 次のページ
 * @returns
 */
export async function searchRequestPosts(
  context,
  searchKeys,
  btn,
  toggle,
  text,
  userName,
  userNameWithKana,
  userId,
  group4,
  admin,
  regularStaffAuth,
  manager,
  mainDepartment,
  dualPositionNames,
  dualPositionIds,
  next
) {
  // すべてOFF の場合は空返却
  if (!toggle.mainTask && !toggle.orderTask && !toggle.employmentTask && !toggle.employmentRegularTask) return []

  // どのメインタスクにも当てはまる条件を生成
  const and = []

  // ソート対象
  let sortItem = text.sortItem
  if (!sortItem) {
    sortItem = 'createDate'
  }
  let sortBy = text.sortBy
  if (!sortBy) {
    sortBy = -1
  }

  // ****ボタン検索****
  // ステータス
  let status = { $ne: 'remove' }
  // 未完了のみ
  if (btn.incomplete) {
    status = 'open'
  }
  and.push({ status })

  // 期限
  let limitDate
  // 期限検索に入力がある場合
  if (text.limitPeriod && text.limitPeriod.start && text.limitPeriod.end) {
    limitDate = { $gte: text.limitPeriod.start, $lte: text.limitPeriod.end }

  // 本日までの期限ボタンON
  } else if (btn.untilToday) {
    limitDate = { $lte: moment().format('YYYY-MM-DD') }
  }

  if (limitDate) {
    and.push({ limitDate })
  }

  // 期限区分
  if (text.kubunLimit === 1 || text.kubunLimit === 2) {
    and.push({ kubunLimit: text.kubunLimit })
  }

  // 担当者（スペースがある場合はAND条件）
  let toStaffName
  let staffOr
  // 自分の担当ON
  if (btn.user) {
    toStaffName = { $regex: spaceAndSearch(userName) }
    // OR検索
    staffOr = { '$or': [] }
    staffOr['$or'].push({ toStaffName })
    staffOr['$or'].push({ 'toStaffName': '未定' })
    // 文字入力がある場合
    // if (text.toStaffName) {
    //   staffOr['$or'].push({ $regex: spaceAndSearch(text.toStaffName) })
    // }
    and.push(staffOr)
  } else if (text.toStaffName) {
    toStaffName = { $regex: spaceAndSearch(text.toStaffName) }
    and.push({ toStaffName })
  }

  // 依頼主（スペースがある場合はAND条件）
  let byUser
  if (btn.byUser) {
    byUser = { $regex: spaceAndSearch(userName) }
    // 文字入力がある場合
    if (text.toStaffName) {
      staffOr['$or'].push({ $regex: spaceAndSearch(text.toStaffName) })
    }
  } else if (text.byUser) {
    byUser = { $regex: spaceAndSearch(text.byUser) }
  }
  if (byUser) {
    and.push({ byUser })
  }

  // ****次の50件を取得する場合****
  if (next && next.createDate && next.requestNo) {
    const row = []
    let ltgt = '$lt'
    if (sortBy === 1) {
      ltgt = '$gt'
    }
    row.push({ [sortItem]: { [ltgt]: next[sortItem] } })
    // ソート条件が指定されている場合（得意先名などから文字が多いので、作成日も加える）
    if (sortItem != 'createDate') {
      row.push({ [sortItem]: next[sortItem], createDate: { $lt: next.createDate } })
      row.push({ [sortItem]: next[sortItem], createDate: next['createDate'], requestNo: { $lt: next.requestNo } })
    } else {
      row.push({ [sortItem]: next[sortItem], requestNo: { $lt: next.requestNo } })
    }

    and.push({ '$or': row })
  }

  // ****テキスト検索****
  // タイトル
  if (text.title) {
    and.push({ inquiry_title: { $regex: text.title, $options: 'i' } })
  }
  // お問い合わせカテゴリー
  if (text.category) {
    and.push({ category: { $regex: text.category } })
  }
  // お客様会社名
  if (text.clientName) {
    and.push({ clientName: { $regex: text.clientName, $options: 'i' } })
  }
  // お客様担当者
  if (text.clientPersonName) {
    and.push({ clientPersonName: { $regex: spaceAndSearch(text.clientPersonName), $options: 'i' } })
  }
  // アポロ管財依頼部署
  if (text.toDepartment) {
    and.push({ toDepartment: { $regex: text.toDepartment } })
  }
  // キーワード検索
  if (text.searchKeyword) {
    const keywords = text.searchKeyword.split(/\s+/g)
    keywords.forEach(function (k) {
      const or = []
      // カッコは無視して検索
      k = removeMark(k)

      searchKeys.forEach(function (searchKey) {
        const row = {}
        row[searchKey] = { $regex: k, $options: 'i' }
        // 検索対象プロパティーのどれかにヒットするようにORに入れる
        or.push(row)
      })

      // 複数のsearchKeyword（スペースで区切られている）があれば、AND条件
      and.push({ '$or': or })
    })
  }
  // ※担当者、依頼主、期限はボタン検索のところで済み

  // ****トグル検索****
  const or = []

  // メインタスクON
  if (toggle.mainTask) {
    // 管理者権限OR人事総務経理所属 ➡ 面接関連全て表示OK
    const YESregular = (admin || manager)

    const row = { '$and': [] }
    // メインタスク
    row['$and'].push({ type: REQUESTPOST_TASKS_TYPE })

    // 管理者権限OR人事総務経理所属
    if (YESregular) {
      // 管理者の場合、非公開もOK
      if (admin) {
        // 除外カテゴリー
        row['$and'].push({ category: { '$nin': ['雇い入れ', '雇い入れ（清掃員）', '雇い入れ（社員）'] } })
      } else {
        // 除外カテゴリー
        row['$and'].push({ category: { '$nin': ['非公開依頼', '雇い入れ', '雇い入れ（清掃員）', '雇い入れ（社員）'] } })
      }

    // 管理者でも人事総務経理でもない場合
    } else {
      // 除外カテゴリー
      row['$and'].push({ category: { '$nin': ['非公開依頼', '雇い入れ', '雇い入れ（清掃員）', '雇い入れ（社員）'] } })

      // 社員面接以外
      row['$and'].push({ interviewsRegularStaff: { $ne: true } })
    }
    or.push(row)

    // 管理者以外
    if (!admin) {
      // 非公開依頼はユーザーが担当者OR依頼主
      const row2 = { '$and': [] }
      row2['$and'].push({ category: ['非公開依頼'] })
      const or2 = { '$or': [] }
      // 担当者IDがユーザーと同じ
      or2['$or'].push({ toStaffId: userId })
      // もしくは依頼主IDがユーザーと同じ
      or2['$or'].push({ byUserId: userId })
      // もしくは担当が未定の場合、同じ所属部署ならOK
      or2['$or'].push({'$and': [{ toStaffName: '未定' }, { toDepartment: mainDepartment }]})
      row2['$and'].push(or2)
      or.push(row2)
    }

    // 管理者でも人事総務経理でもない場合
    if (!YESregular) {
      // 社員面接
      const row2 = { '$and': [] }
      row2['$and'].push({ interviewsRegularStaff: true })
      const or2 = { '$or': [] }
      // 担当者がユーザーと同じ
      or2['$or'].push({ toStaffName: userNameWithKana })
      // もしくは依頼主がユーザーと同じ
      or2['$or'].push({ byUser: userNameWithKana })

      // 社員面接権限あり
      if (regularStaffAuth && dualPositionNames && dualPositionNames.length) {
        // 同じ部署であればOk
        or2['$or'].push({ toDepartment: { $in: dualPositionNames } })
      }
      row2['$and'].push(or2)
      or.push(row2)
    }
  }

  // DC雇い入れON
  if (toggle.employmentTask) {
    const row = { '$and': [] }
    // サブタスクマスタまでヒットしてしまうため
    row['$and'].push({ type: REQUESTPOST_TASKS_TYPE })
    // 対象カテゴリー
    row['$and'].push({ category: { '$in': ['雇い入れ', '雇い入れ（清掃員）'] } })
    // 社員ではない
    row['$and'].push({ employmentRegularStaff: { $ne: true } })
    or.push(row)
  }

  // 社員雇い入れON、トグル表示権限あり
  const isEmployment = (admin || manager || group4)
  if (toggle.employmentRegularTask && isEmployment) {
    const row = { '$and': [] }
    // 対象カテゴリー
    row['$and'].push({ category: { '$in': ['雇い入れ', '雇い入れ（社員）'] } })
    // 社員である
    row['$and'].push({ employmentRegularStaff: true })

    // 管理者でも、人事でもない場合
    if (!admin && !manager) {
      row['$and'].push({
        '$or': [
          // 同じ部署のみOK（入社の時の項目）
          { employmentDepartmentId: { '$in': dualPositionIds } },
          // 依頼主が自分
          { byUser: userNameWithKana },
          { byUserId: userId },
          // 担当が自分
          { toStaffName: userNameWithKana },
          { toStaffId: userId },
          // 担当未定の場合、同じ部署OK
          {'$and': [
            { toStaffName: '未定' },
            { toDepartment: mainDepartment }
          ]}
        ]
      })
    }
    or.push(row)

  }

  // 受注ON
  if (toggle.orderTask) {
    // 受注タスク
    or.push({ type: ORDER_TASKS_TYPE })
  }

  and.push({ '$or': or })

  // 検索条件
  const find = { '$and': and }
  // console.log(JSON.stringify(find, null, 2));

  // ソート
  let sort = { [sortItem]: sortBy, requestNo: -1 }
  if (sortItem != 'createDate') {
    sort = { [sortItem]: sortBy, createDate: -1, requestNo: -1 }
  }
  // 取得件数
  const limit = 50
  // 取得フィールド
  const project = {
    type: 1,
    category: 1,
    employmentRegularStaff: 1,
    createDate: 1,
    requestNo: 1,
    status: 1,
    inquiry_title: 1,
    clientName: 1,
    clientPersonName: 1,
    limitDate: 1,
    toStaffName: 1,
    toStaffId: 1,
    byUser: 1,
    byUserId: 1,
    toDepartment: 1,
    toDepartmentId: 1,
    employmentDepartmentId: 1,
    temporarySaveFlag: 1,
    accompanyId: 1,
    estimateNo: 1,
    // 以下は、DC面接完了時の雇い入れ自動登録に必要
    interviewsRegularStaff: 1,
    interviewsResult: 1,
    // 期限区分
    kubunLimit: 1
  }

  try {
    let responseData = []

    responseData = await context.$pigeon.findTasks(find, project, sort, limit)
    let searchRequestPosts = responseData || []
    const lastData = responseData[responseData.length - 1]
    // console.log('最後のデータ')
    // console.log(lastData)

    let sub = []
    const res = []

    // サブタスク表示
    if (toggle.withSub && searchRequestPosts.length) {
      const mainIds = searchRequestPosts.map(m => m._id)
      const subAnd = []
      subAnd.push({ status: { $ne: 'remove' } })
      if (toggle.orderTask) {
        subAnd.push({ type: { '$in': ['task_request', 'task_request_order'] } })
        subAnd.push({ '$or': [{ requestPostId: { '$in': mainIds } },{ orderId: { '$in': mainIds } }] })
      } else {
        subAnd.push({ type: 'task_request' })
        subAnd.push({ requestPostId: { '$in': mainIds } })
      }

      const subSort = { displayOrder: 1 }
      const subProject = {
        type: 1,
        requestPostId: 1,
        orderId: 1,
        requestTask: 1,
        toStaffName: 1,
        limitDate: 1,
        status: 1
      }
      sub = await context.$pigeon.findTasks({ '$and': subAnd }, subProject, subSort, 0)
    }

    // サブタスクjoin、データ成型
    for (let i = 0; i < searchRequestPosts.length; i++) {
      const main = searchRequestPosts[i]

      // ステータス、編集、仮登録、依頼登録
      if (main.status == 'open') {
        main.statusText = '未完了'
      } else if (main.status == 'done') {
        main.statusText = '完了済'
      }

      // お問い合わせカテゴリー を文字列に変換
      let category = main.category
      if (category) {
        main.categoryString = category.join(' , ')
      } else {
        main.categoryString = ''
      }

      // ステータスアイコンをセット
      setStatusIcon(main)
      // 背景色をセット
      setRowColor(main)

      // 期限区分を文字に変換
      if (main.kubunLimit == 1) {
        main.kubunLimitString = '短期'
        main.kubunLimitColor = 'gray-limit'
      } else if (main.kubunLimit == 2) {
        main.kubunLimitString = '長期'
        main.kubunLimitColor = 'white-limit'
      } else {
        main.kubunLimitString = ''
        main.kubunLimitColor = ''
      }

      res.push(main)

      if (sub && sub.length) {
        for (let j = 0; j < sub.length; j++) {
          const s = sub[j]
          if (s.requestPostId == main._id || s.orderId == main._id) {
            // ステータスアイコンをセット
            setStatusIcon(s)
            // 背景色をセット
            setRowColor(s)
            // タイトル
            s.inquiry_title = s.requestTask
            res.push(s)
          }
        }
      }
    }

    return { list: res, lastData }
  } catch (error) {
    console.log('メインタスク一覧取得 error !!!')
    console.log(error)
    alert('エラーが発生しました。\r\n' + error)
    return []
  }
}

/**
 * ステータスアイコンをセット
 * @param row 対象データ
 */
function setStatusIcon(row) {
  if(row.status == 'open' && row.limitDate >= today) {
    row.iconName = ''
  } else if ((row.status == 'open' && row.limitDate < today)) {
    row.iconName = 'ExclamationCircle'
    row.iconColor = 'red'
  } else if(row.status == 'done') {
    row.iconName = 'CheckCircle'
    row.iconColor = 'green'
  } else {
    console.log('MinusCircle')
    console.log(row)
    row.iconName = 'MinusCircle'
  }
}

/**
 * 行の背景色をセット
 * @param rowData 行データ
 */
function setRowColor(row) {
  if (row.limitDate < today && row.status == 'open') {
    row.color = 'bg-red-100'
  } else if(row.status == 'done') {
    row.color = 'bg-blue-100'
  } else if (row.limitDate == today && row.status == 'open') {
    row.color = 'bg-yellow-100'
  } else {
    row.color = 'bg-green-100'
  }
}

/**
 * スペースがある場合、AND検索にする
 * @param {*} val
 * @returns
 */
function spaceAndSearch(val) {
  const v = val.split(/\s+/g)

  let res = ''
  // スペースなし
  if (v.length == 1) {
    res = v[0]

  // スペースある
  } else {
    // eslint-disable-next-line no-irregular-whitespace
    let re = val.replace(/ |　/g, ')(?=.*')
    res = `^(?=.*${re}).*$`
  }
  return res
}

  /**
   * 進捗一覧取得
   * @param {*} context
   * @param {*} searchKeys キーワード検索対象項目
   * @param {*} btn ボタン検索
   * @param {*} toggle トグル検索
   * @param {*} text 文字列検索
   * @param {*} userName ログインユーザー名
   * @param {*} userNameWithKana ログインユーザー名カナつき
   * @param {*} userId ログインユーザーID
   * @param {*} group4 G4以上
   * @param {*} admin 管理者権限
   * @param {*} regularStaffAuth 正社員面接権限
   * @param {*} manager 人事経理総務
   * @param {*} mainDepartment メイン部署
   * @param {*} dualPositionNames 兼任部署含む所属部署名
   * @param {*} dualPositionIds 兼任部署含む所属部署ID
   * @param {*} next 次のページ
   * @returns
   */
  export async function searchSubList(
    context,
    searchKeys,
    btn,
    toggle,
    text,
    userName,
    userNameWithKana,
    userId,
    group4,
    admin,
    regularStaffAuth,
    manager,
    mainDepartment,
    dualPositionNames,
    dualPositionIds,
    next
  ) {
    // すべてOFF の場合は空返却
    if (!toggle.mainTask && !toggle.orderTask && !toggle.employmentTask && !toggle.employmentRegularTask) return []

    let aggregate = []

    const nameSpaceAnd = spaceAndSearch(userName)

    // ********メインタスクの条件を生成********
    const matchMain = { $and: [] }

    // ****ボタン検索****

    // ステータス（メイン）
    // デフォルトは削除以外
    let statusMain = { $ne: 'remove' }
    // 未完了のみ（メイン）ON
    if (btn.incompleteMain) {
      statusMain = 'open'
    }
    // 取り消し受注タスクON
    if (btn.removeOrder) {
      statusMain = 'remove'
    }
    matchMain.status = statusMain

    // 担当者（スペースがある場合はAND条件）
    // メインが自分の担当ON（入力分はサブの担当とOR条件）
    if (btn.mainUser) {
      matchMain.toStaffName = { $regex: nameSpaceAnd }
    }

    // ****テキスト検索****

    // お問い合わせNo
    if (text.requestNo) {
      matchMain.requestNo = { $regex: utils.hankaku(text.requestNo) }
    }
    // 作成
    if (text.createPeriod && text.createPeriod.start && text.createPeriod.end) {
      matchMain.createDate = { $gte: text.createPeriod.start + ' 00:00:00', $lte: text.createPeriod.end + ' 23:59:59' }
    }
    // 期限
    if (text.limitPeriod && text.limitPeriod.start && text.limitPeriod.end) {
      matchMain.limitDate = { $gte: text.limitPeriod.start, $lte: text.limitPeriod.end }
    }
    // タイトル
    if (text.titleMain) {
      matchMain.inquiry_title = { $regex: text.titleMain, $options: 'i' }
    }
    // お問い合わせカテゴリー
    if (text.category) {
      matchMain.category = { $regex: text.category }
    }

    // キーワード検索
    if (text.searchKeyword) {
      const keywords = text.searchKeyword.split(/\s+/g)
      keywords.forEach(function (k) {
        const or = []
        // カッコは無視して検索
        k = removeMark(k)

        searchKeys.forEach(function (searchKey) {
          const row = {}
          row[searchKey] = { $regex: k, $options: 'i' }
          // 検索対象プロパティーのどれかにヒットするようにORに入れる
          or.push(row)
        })

        // 複数のsearchKeyword（スペースで区切られている）があれば、AND条件
        matchMain.$and.push({ '$or': or })
      })
    }

    // ****トグル検索****

    const or = []

    // メインタスクON
    if (toggle.mainTask) {
      // 管理者権限OR人事総務経理所属or権限 ➡ 面接関連表示
      const YESregular = (admin || manager || regularStaffAuth)

      const row = { '$and': [] }
      // メインタスク
      row['$and'].push({ type: REQUESTPOST_TASKS_TYPE })

      // 管理者権限OR人事総務経理所属or権限
      if (YESregular) {
        // 除外カテゴリー
        row['$and'].push({ category: { '$nin': ['雇い入れ', '雇い入れ（清掃員）', '雇い入れ（社員）'] } })

      // 管理者でも人事総務経理でも権限もない場合
      } else {
        // 除外カテゴリー
        row['$and'].push({ category: { '$nin': ['雇い入れ', '雇い入れ（清掃員）', '雇い入れ（社員）'] } })

        // 社員面接以外
        row['$and'].push({ interviewsRegularStaff: { $ne: true } })
      }
      or.push(row)
    }

    // DC雇い入れON
    if (toggle.employmentTask) {
      const row = { '$and': [] }
      // 対象カテゴリー
      row['$and'].push({ category: { '$in': ['雇い入れ', '雇い入れ（清掃員）'] } })
      // 社員ではない
      row['$and'].push({ employmentRegularStaff: { $ne: true } })
      or.push(row)
    }

    // 社員雇い入れON、トグル表示権限あり
    const isEmployment = (admin || manager || group4)
    if (toggle.employmentRegularTask && isEmployment) {
      const row = { '$and': [] }
      // 対象カテゴリー
      row['$and'].push({ category: { '$in': ['雇い入れ', '雇い入れ（社員）'] } })
      // 社員である
      row['$and'].push({ employmentRegularStaff: true })

      or.push(row)
    }

    // 受注ON
    if (toggle.orderTask) {
      // 受注タスク
      or.push({ type: ORDER_TASKS_TYPE })
    }

    matchMain.$and.push({ '$or': or })

    aggregate.push({ $match: matchMain })

    const idStr = {
      $addFields: {
        _idStr: { $toString: "$_id" }
      }
    }
    aggregate.push(idStr)

    // ********サブタスクをメインタスクにマージ********
    // localFieldは使えない。サブのtypeを絞らないと見積りもjoinされるため
    const lookup =
    {
      $lookup: {
        from: "Tasks",
        let: {
          mainId: { $toString: "$_id" }
        },
          // localField: "_idStr",
          // foreignField: "requestPostId",
        pipeline: [
          {
            $project: {
              _id: 1,
              type: 1,
              requestPostId: 1,
              orderId: 1,
              taskRequestRequestNo: 1,
              orderTaskRequestOrderNo: 1,
              subTaskNo: 1,

              requestTask:1,
              limitDate: 1,
              finalCompletionTask: 1,
              doneDate: 1,
              doneStaffName: 1,
              details: 1,
              addTask: 1,
              memo: 1,

              departmentId: 1,
              departmentName: 1,
              toStaffId: 1,
              toStaffName: 1,
              toStaffValue: 1,
              displayOrder: 1, // これがないとソート効かない

              status: 1
            }
          },
          {
            $match: {
              type: { $in: ["task_request", "task_request_order"] },
              status: { $ne: "remove" },
              $expr: {
                $or: [
                  { $eq: ["$requestPostId", "$$mainId"] },
                  { $eq: ["$orderId", "$$mainId"] }
                ]
              }
            }
          },

          {
            $sort: {
              displayOrder: 1
            }
          }
        ],
        as: "subTasks"
      }
    }
    aggregate.push(lookup)

    // ********サブタスクの条件を生成********

    const subAnd = []

    // 未完了（サブ）がON
    if (btn.incompleteSub) {
      subAnd.push({ $eq: ["$$sub.status", "open"] })
    }

    // サブ担当者が自分と未定分がON
    if (btn.subUser) {
      const $or = []
      $or.push({ $eq: ["$$sub.toStaffName", "未定"] })
      $or.push({ $regexMatch: { input: { $ifNull: ["$$sub.toStaffName", ""] }, regex: nameSpaceAnd } })
      subAnd.push({ $or: $or })
    }
    // 期限が本日まで
    if (btn.untilToday) {
      subAnd.push({ $lte: ["$$sub.limitDate", today] })
    }
    // サブタスク名
    if (text.titleSub) {
      subAnd.push({ $regexMatch: { input: "$$sub.requestTask", regex: text.titleSub, options: "i" } })
    }
    // 部署
    if (text.toDepartment) {
      subAnd.push({ $regexMatch: { input: "$$sub.departmentName", regex: text.toDepartment } })
    }
    const addFields2 =
    {
      $addFields: {
        hasMatchedSub: {
          $anyElementTrue: {
            $map: {
              input: "$subTasks",
              as: "sub",
              in: {
                $and: subAnd
              }
            }
          }
        }
      }
    }

    aggregate.push(addFields2)
    aggregate.push({ $match: { hasMatchedSub: true } }) // これがないと検索が適用されない

    // ********メイン・サブどちらかに当てはまれば取得する条件でメインタスクを検索********

    // 担当者（メインORサブ）
    let textStaffName = ''
    if (text.toStaffName) {
      textStaffName = text.toStaffName
      const addFields3 = {
        $addFields: {
          hasMatchedStaff: {
            $or: [
              {
                $regexMatch: {
                  input: { $ifNull: ["$toStaffName", ""] },
                  regex: spaceAndSearch(textStaffName)
                }
              },
              {
                $anyElementTrue: {
                  $map: {
                    input: "$subTasks",
                    as: "sub",
                    in: {
                      $regexMatch: {
                        input: { $ifNull: ["$$sub.toStaffName", ""] },
                        regex: spaceAndSearch(textStaffName)
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
      aggregate.push(addFields3)
      aggregate.push({ $match: { hasMatchedStaff: true } }) // これがないと検索が適用されない
    }

    // 非公開依頼取得
    // メインタスクON、かつ管理者ではない場合
    if (toggle.mainTask && !admin) {
      const addFieldsPrivate = {
        $addFields: {
          hasMatchedPrivate: {
            $cond: [
              // 条件：非公開タスク
              { $in: ["非公開依頼", "$category"] },

              // 条件に一致する場合➡（自分がメイン担当orメイン依頼主orサブ担当が未定かつ自分の部署or自分がサブ担当）を取得
              {
                $or: [
                  // メイン担当が自分
                  { $eq: ["$toStaffId", userId] },
                  // もしくはメイン担当が未定かつ同じ部署
                  {
                    $and: [
                      { $eq: ["$toStaffName", "未定"] },
                      { $eq: ["$toDepartment", mainDepartment] }
                    ]
                  },
                  // もしくはメイン依頼主が自分
                  { $eq: ["$byUserId", userId] },
                  // もしくはサブの担当が未定かつ同じ部署、もしくはサブ担当が自分
                  {
                    $anyElementTrue: {
                      $map: {
                        input: "$subTasks",
                        as: "sub",
                        in: {
                          $or: [
                            {
                              $and: [
                                { $eq: ["$$sub.toStaffName", "未定"] },
                                { $eq: ["$$sub.departmentName", mainDepartment] }
                              ]
                            },
                            { $eq: ["$$sub.toStaffId", userId] }
                          ]
                        }
                      }
                    }
                  }
                ]
              },

              // 条件に一致しない（非公開以外）場合はtrue
              true
            ]

          }
        }
      }
      aggregate.push(addFieldsPrivate)
      aggregate.push({ $match: { hasMatchedPrivate: true } }) // これがないと検索が適用されない
    }

    // 社員の面接関連タスク
    // メインタスクON、かつ権限あり、かつ管理者でも、人事でもない場合
    if (toggle.mainTask && regularStaffAuth && !admin && !manager) {
      const addFieldsRegularInte = {
        $addFields: {
          hasMatchedRegularInte: {
            $cond: [
              // 条件： 面接関連のカテゴリーかつ、社員フラグON
              {
                $and: [
                  { $in: ["面接関連", "$category"] },
                  { $eq: ["$interviewsRegularStaff", true] }
                ]
              },

              // 条件に一致する場合➡（自分がメイン担当orメイン依頼主orサブ担当が未定かつ自分の部署or自分がサブ担当）を取得
              {
                $or: [
                  // メイン担当が自分
                  {
                    $regexMatch: {
                      input: { $ifNull: ["$toStaffName", ""] },
                      regex: nameSpaceAnd
                    }
                  },
                  // もしくはメイン依頼主が自分
                  {
                    $regexMatch: {
                      input: { $ifNull: ["$byUser", ""] },
                      regex: nameSpaceAnd
                    }
                  },
                  // もしくはメイン担当が未定かつ同じ部署
                  {
                    $and: [
                      { $eq: ["$toStaffName", "未定"] },
                      { $eq: ["$toDepartment", mainDepartment] }
                    ]
                  },
                  // もしくは依頼先部署が自分と同じ
                  {
                    $in: ["$toDepartment", dualPositionNames]
                  },
                  // もしくはサブの担当が未定かつ同じ部署、もしくはサブ担当が自分
                  {
                    $anyElementTrue: {
                      $map: {
                        input: "$subTasks",
                        as: "sub",
                        in: {
                          $or: [
                            {
                              $and: [
                                { $eq: ["$$sub.toStaffName", "未定"] },
                                { $eq: ["$$sub.departmentName", mainDepartment] }
                              ]
                            },
                            {
                              $regexMatch: {
                                input: { $ifNull: ["$$sub.toStaffName", ""] },
                                regex: nameSpaceAnd
                              }
                            },
                          ]
                        }
                      }
                    }
                  }
                ]
              },

              // 条件に一致しない（面接関連のカテゴリーかつ、社員フラグON以外）場合はtrue
              true
            ]
          }
        }
      }

      aggregate.push(addFieldsRegularInte)
      aggregate.push({ $match: { hasMatchedRegularInte: true } }) // これがないと検索が適用されない
    }

    // 社員雇い入れタスク
    // 社員雇い入れタスクON、かつ管理者でも、人事でもない場合
    if (toggle.employmentRegularTask && isEmployment && !admin && !manager) {
      const addFieldsRegularEmp = {
        $addFields: {
          hasMatchedRegularEmp: {
            $cond: [
              // 条件： '雇い入れ', '雇い入れ（社員）'のカテゴリーかつ、雇い入れ社員フラグON
              {
                $and: [
                  {
                    $or: [
                      { $in: ["雇い入れ", "$category"] },
                      { $in: ["雇い入れ（社員）", "$category"] }
                    ]
                  },
                  { $eq: ["$employmentRegularStaff", true] }
                ]
              },

              // 条件に一致する場合➡（自分がメイン担当orメイン依頼主orサブ担当が未定かつ自分の部署or自分がサブ担当）を取得
              {
                $or: [
                  // メイン担当が自分
                  {
                    $regexMatch: {
                      input: { $ifNull: ["$toStaffName", ""] },
                      regex: nameSpaceAnd
                    }
                  },
                  // もしくはメイン担当が未定かつ同じ部署
                  {
                    $and: [
                      { $eq: ["$toStaffName", "未定"] },
                      { $eq: ["$toDepartment", mainDepartment] }
                    ]
                  },
                  // もしくはメイン依頼主が自分
                  {
                    $regexMatch: {
                      input: { $ifNull: ["$byUser", ""] },
                      regex: nameSpaceAnd
                    }
                  },
                  // もしくは新入社員の部署が自分と同じ
                  {
                    $gt: [
                      {
                        $size: {
                          $setIntersection: [
                            "$employmentDepartmentId",
                            dualPositionIds
                          ]
                        }
                      },
                      0
                    ]
                  },
                  // もしくはサブの担当が未定かつ同じ部署、もしくはサブ担当が自分
                  {
                    $anyElementTrue: {
                      $map: {
                        input: "$subTasks",
                        as: "sub",
                        in: {
                          $or: [
                            {
                              $and: [
                                { $eq: ["$$sub.toStaffName", "未定"] },
                                { $eq: ["$$sub.departmentName", mainDepartment] }
                              ]
                            },
                            {
                              $regexMatch: {
                                input: { $ifNull: ["$$sub.toStaffName", ""] },
                                regex: nameSpaceAnd
                              }
                            },
                          ]
                        }
                      }
                    }
                  }
                ]
              },

              // 条件に一致しない（'雇い入れ', '雇い入れ（社員）'のカテゴリーかつ、雇い入れ社員フラグON以外）場合はtrue
              true
            ]
          }
        }
      }
      aggregate.push(addFieldsRegularEmp)
      aggregate.push({ $match: { hasMatchedRegularEmp: true } }) // これがないと検索が適用されない
    }

    const addFields6 =
      // サブタスクがあるもののみ
      {
        $addFields: {
          hasSubTasks: {
            $gt: [
              { $size: "$subTasks" },
              0
            ]
          }
        }
      }
    aggregate.push(addFields6)
    aggregate.push({ $match: { hasSubTasks: true } }) // これがないと検索が適用されない

    // ****ソート条件****
    // ソート対象項目
    let sortItem = text.sortItem

    // ソート項目なし
    if (!sortItem) {
      sortItem = 'createDate'
    }
    // サブの期限が速い順
    if (sortItem == 'earliestLimitDate') {
      const earliestLimitSort = {
        $addFields: {
          earliestLimitDate: {
            $let: {
              vars: {
                openDates: {
                  $map: {
                    input: {
                      $filter: {
                        input: "$subTasks",
                        as: "sub",
                        cond: { $eq: ["$$sub.status", "open"] }
                      }
                    },
                    as: "s",
                    in: "$$s.limitDate"
                  }
                }
              },
              in: {
                $cond: [
                  { $gt: [{ $size: "$$openDates" }, 0] },
                  { $min: "$$openDates" },
                  null
                ]
              }
            }
          }
        }
      }

      aggregate.push(earliestLimitSort)
    }

    // 昇降順
    let sortBy = text.sortBy
    if (!sortBy) {
      sortBy = -1
    }

    // ****次の100件を取得する場合****
    // console.log(next)
    if (next && next.createDate && next.requestNo) {
      const row = []
      let ltgt = '$lt'
      if (sortBy === 1) {
        ltgt = '$gt'
      }
      row.push({ [sortItem]: { [ltgt]: next[sortItem] } })
      // ソート条件が指定されている場合（得意先名などから文字が多いので、作成日も加える）
      if (sortItem != 'createDate') {
        row.push({ [sortItem]: next[sortItem], createDate: { $lt: next.createDate } })
        row.push({ [sortItem]: next[sortItem], createDate: next['createDate'], requestNo: { $lt: next.requestNo } })
      } else {
        row.push({ [sortItem]: next[sortItem], requestNo: { $lt: next.requestNo } })
      }

      if (sortItem == 'earliestLimitDate') {
        aggregate.push({ $match: { $or: row } })
      } else {
        matchMain.$and.push({ '$or': row })
      }
    }

    // ソート
    let sort = { [sortItem]: sortBy, requestNo: -1 }
    if (sortItem != 'createDate') {
      sort = { [sortItem]: sortBy, createDate: -1, requestNo: -1 }
    }

    const addFields7 = [
      // ソート
      {
        $sort: sort
      },
      // limit
      {
        $limit: 100
      },
      // フィールド絞り込み（一覧の1行分のデータ）
      {
        $project: {
          _id: 1,
          // category2: 1,
          category: 1,
          // 雇い入れ（清掃員）の進み表のサブタスクの選択肢用：新しい雇い入れ（dcNew2）なら「雇用指示登録画面」、古い雇い入れなら「登録済み一覧へ」（清掃員コードでその人を開く）
          dcNew2: 1,
          employmentStaffNumber: 1,
          employmentRegularStaff: 1,
          requestNo: 1,
          inquiry_title: 1,
          toDepartment: 1,
          toDepartmentId: 1,
          toStaffName: 1,
          toStaffId: 1,
          byUser: 1,
          byUserId: 1,
          limitDate: 1,
          createDate: 1,
          commonFile: 1,
          status: 1,
          estimateNo: 1,
          // employmentRegularStaff: 1,
          // employmentDepartmentId: 1,
          // interviewsRegularStaff: 1,
          // interviewsResult: 1,
          // interviewsKana: 1,
          // employmentKana: 1,
          // employmentBuildingName: 1,
          apology: 1,
          reflect: 1,
          type: 1,

          subTasks: 1,
          earliestLimitDate : 1
        }
      }
    ]
    aggregate = aggregate.concat(addFields7)
    // console.log(aggregate)

    try {
      let responseData = []

      responseData = await context.$pigeon.aggregateTasks(aggregate)
      let searchRequestPosts = responseData || []
      const lastData = responseData[responseData.length - 1]
      // console.log('最後のデータ')
      // console.log(lastData)

      const res = []

      // データ成型
      for (let i = 0; i < searchRequestPosts.length; i++) {
        const main = searchRequestPosts[i]
        // お問い合わせカテゴリー を文字列に変換
        let category = main.category
        if (category) {
          main.categoryString = category.join(' , ')
        } else {
          main.categoryString = ''
        }
        res.push(main)
      }
      // console.log(res)

      return { list: res, lastData }
    } catch (error) {
      console.log('進捗一覧取得 error !!!')
      console.log(error)
      alert('エラーが発生しました。\r\n' + error)
      return []
    }
  }

/**
 * カッコは無視して検索
 * @param {*} keyword 検索キーワード入力値
 * @returns
 */
function removeMark(keyword){
  // 前後にあるカッコは削除
  if (['（', '(', '）', ')'].includes(keyword.substring(0, 1))) {
    keyword = keyword.substring(1)
  }
  if (['（', '(', '）', ')'].includes(keyword.substring(keyword.length-1, keyword.length))) {
    keyword = keyword.substring(0, keyword.length-1)
  }

  // 文字列内にカッコがあれば、正規表現でAND条件にする
  let target = keyword
  // (?=.*)は問題ないので、対象の記号を全置換
  target = target.replace(/（|\(|）|\)/g, ')(?=.*')
  if (target != keyword) {
    target = `^(?=.*${target}).*$`
    keyword = target
  }
  return keyword
}

// リクエストポストのステータス変更
export async function markAsDone(context, allocationId) {
  try {
    await context.$pigeon.completeTask(allocationId)
    return true
  } catch (error) {
    console.log('markAsDone error !!!')
    console.log(error)
    return false
  }
}

// リクエストポスト 削除のみステータス検索
export async function searchRequestPostsRemoveOnly(context) {

  const searchCondition = {
    searchCondition: {
      type: REQUESTPOST_TASKS_TYPE,
      status: "remove"
    }
  }

  const responseData = await context.$pigeon.searchTasks(searchCondition)
  const searchRequestPosts = responseData || []
  return searchRequestPosts
}

/**
 * リクエストポストデータをステータスによって絞込み
 * @param {*} context
 * @param {*} status ステータス
 * @returns
 */
export async function searchByStatus(context, status) {

  const searchCondition = {
    searchCondition: {
      type: REQUESTPOST_TASKS_TYPE,
      status
    }
  }

  try {
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const result = responseData || []
    return result
  } catch (error) {
    console.log('requestPostManager.searchByStatus error !!!')
    console.log(error)
    return []
  }
}

/**
 * 論理削除
 * @param {*} context
 * @param {*} id requestPostId
 * @returns
 */
export async function deleteMain(context, id) {
  try {
    await context.$pigeon.deleteTask(id)
    return true
  } catch (error) {
    console.log('deleteMain error !!!')
    console.log(error)
    return false
  }
}

export async function upDateInterviews(context, _id) {
  const data = await getRequestPost(context, _id)
  if (data) {
    // 雇い入れフラグをtrueにする（同じ面接から複数の雇い入れを作成するのを防ぐため）
    data.isEmployment = true
    update(context, data, false)
  }
}

/**
 * 特定の条件で更新（該当データがあれば更新、なければ挿入、特定の項目のみ更新）
 * 条件にステータスも入れるか入れないか必ず確認してから、使ってください。
 * @param {*} context
 * @param {*} filter 条件
 * @param {*} data 更新する内容
 */
export async function upDateOne(context, filter, data) {
  try {
    await context.$pigeon.updateOne(filter, data)
    return true
  } catch (error) {
    console.log('requestPostManager.upDateOne error !!!')
    alert(error)
    console.log(error)
    return false
  }
}

/**
 * メインタスク特定の項目のみ更新
 * @param {*} context
 * @param {*} data
 * @returns
 */
export async function upDateOneForMain(context, requestNo, data) {
  try {
    const filter = {
      type: REQUESTPOST_TASKS_TYPE,
      requestNo
    }
    return await upDateOne(context, filter, data)

  } catch (error) {
    console.log('requestPostManager.upDateOneForMain error !!!')
    console.log(error)
    return false
  }
}

/**
 * 社員面接専用のチャットワークルームID取得
 * @param {*} context
 * @param {*} filter 検索条件
 * @returns 取得データの1行目
 */
export async function searchInterviewsChatRoomID(context, filter) {
  const searchCondition = {
    searchCondition: {
      type: INTERVIEWS_ROOMID_TASKS_TYPE,
      ...filter,
      status: { $ne: 'remove' }
    }
  }

  try {
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const result = responseData || []
    if (result && result.length) {
      return result[0]
    } else {
      return null
    }
  } catch (error) {
    console.log('requestPostManager.searchInterviewsChatRoomID error !!!')
    console.log(error)
    return []
  }
}

/**
 * 社員面接専用のチャットワークルームID取得（全て）
 * @param {*} context
 * @param {*} filter 検索条件
 * @returns
 */
export async function getInterviewsChatRoomID(context, filter) {
  // 中途
  let newGrad = { $ne: true }

  // 新卒
  if (filter == 3) {
    newGrad = true
  }
  const searchCondition = {
    searchCondition: {
      type: INTERVIEWS_ROOMID_TASKS_TYPE,
      status: { $ne: 'remove' },
      newGrad
    },
    sort: {
      gradYear: -1,
      department: 1,
      categoryId: 1
    }
  }

  try {
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const result = responseData || []
    return result
  } catch (error) {
    console.log('requestPostManager.getInterviewsChatRoomID error !!!')
    console.log(error)
    return []
  }
}

/**
 * 社員面接専用のチャットワークルームID保存
 * @param {*} context
 * @param {*} data 保存データ
 * @returns
 */
export async function saveInterviewsChatRoomID(context, data) {
  try {
    if (data._id) {
      // 更新
      await context.$pigeon.updateTask(data._id, data, {})
    } else {
      // 新規
      await context.$pigeon.registerTask(INTERVIEWS_ROOMID_TASKS_TYPE, data, {})
    }
    return true
  } catch (error) {
    console.log('requestPostManager.saveInterviewsChatRoomID error !!!')
    console.log(error)
    alert(error)
    return false
  }
}

/**
 * データ論理削除
 */
export async function deleteTask(context, data) {
  try {
    await context.$pigeon.deleteTask(data._id)
    return true
  } catch (error) {
    console.log('requestPostManager.deleteTask error !!!')
    console.log(error)
    alert(error)
    return false
  }
}

/**
 * 同行メインタスク削除
 * @param {*} context
 * @param {*} data
 * @returns
 */
export async function deleteAccompanyTask(context, data) {
  try {
    // 該当する同行メインタスク取得
    const searchCondition = {
      searchCondition: {
        type: REQUESTPOST_TASKS_TYPE,
        accompanyId: data.id,
        status: { $ne: 'remove' },
      }
    }
    const responseData = await context.$pigeon.searchTasks(searchCondition)

    // 該当のメインタスク削除
    if (responseData && responseData[0]) {
      await context.$pigeon.deleteTask(responseData[0]._id)
    }
    return true
  } catch (error) {
    console.log('requestPostManager.deleteAccompanyTask error !!!')
    console.log(error)
    alert(error)
    return false
  }
}

/**
 * 同行メインタスク完了
 * @param {*} context
 * @param {*} data
 * @returns
 */
export async function doneAccompanyTask(context, data) {
  try {
    // 該当する同行メインタスク取得
    const searchCondition = {
      searchCondition: {
        type: REQUESTPOST_TASKS_TYPE,
        accompanyId: data.id,
        status: { $ne: 'remove' },
      }
    }
    const responseData = await context.$pigeon.searchTasks(searchCondition)

    // 該当のメインタスク完了
    if (responseData && responseData[0]) {
      await context.$pigeon.completeTask(responseData[0]._id)
    }
    return true
  } catch (error) {
    console.log('requestPostManager.doneAccompanyTask error !!!')
    console.log(error)
    alert(error)
    return false
  }
}

/**
 * 社員面接タスク特定の項目のみ更新
 * @param {*} context
 * @param {*} data
 * @returns
 */
export async function upDateOneForInterviews(context, requestNo, data) {
  try {
    const filter = {
      type: REQUESTPOST_TASKS_TYPE,
      category: '面接関連',
      requestNo
    }
    return await upDateOne(context, filter, data)

  } catch (error) {
    console.log('requestPostManager.upDateOneForInterviews error !!!')
    console.log(error)
    return false
  }
}

/**
 * 面接タスク完了時に雇い入れ自動登録
 * 清掃員の申請画面（AkbsInputForm）で面接だけの申請を「申請」したときにも呼ぶ（面接タスクを完了にしたあと。2026-09-23）
 * @param {*} context
 * @param {*} data 面接のメインタスク（category・interviewsResult・requestNo・interviewsRegularStaff があればよい）
 * @returns { id, requestNo } 作った雇い入れメインタスク（作らなかった・作れなかったときは null）
 */
export async function autoEmployTaskSave(context, data) {
  // 面接関連に限定、清掃員に限定
  if (data.category[0] !== '面接関連' || data.interviewsRegularStaff) {
    return null
  }
  // 採用に限定
  if (!data.interviewsResult || data.interviewsResult[0] !== '採用') {
    return null
  }
  // 雇い入れメインタスク登録結果
  let saved
  let rp

  try {
    // まだ雇い入れが作られていない対象の面接データを取得
    let find = {
      status: { $ne: 'remove' },
      type: REQUESTPOST_TASKS_TYPE,
      category: "面接関連",
      requestNo: data.requestNo,
      isEmployment: { $ne: true }
    }
    const res = await context.$pigeon.findTasks(find)

    // まだ対象の雇い入れが作られていない場合
    if (res && res.length) {
      // 面接データを雇い入れに反映
      rp = setEmployFromInterview(context.$store.getters.user, res[0])

      // 保存
      saved = await register(context, rp)
      if (saved.id) {
        // 反映元の雇い入れもフラグを立てて更新
        const filter = {
          status: { $ne: 'remove' },
          type: REQUESTPOST_TASKS_TYPE,
          category: "面接関連",
          requestNo: data.requestNo
        }
        await upDateOne(context, filter, { isEmployment: true })

        rp._id = saved.id
        rp.requestNo = saved.requestNo

        // メインタスク登録のチャット通知（ログインユーザーが未定ということはないので、ユーザーを比較せずにチャット送信する）
        chatworkMessage.autoEmployTaskChat(context, rp)
      } else {
        alert('エラーが発生し、雇い入れタスクを自動登録できませんでした。手動にてお願いします。')
        return null
      }
    }
  } catch (error) {
    console.log('requestPostManager.autoEmployTaskSave error !!!')
    console.log(error)
    alert(error)
  }

  // サブタスクを登録
  if (saved && saved.id) {
    await taskRequestManager.autoEmploySubTaskSave(context, saved.id, rp)
    // 面接だけで先に AKBS の申請を進めていた（承認待ち・AKBS登録済み）ときは、今作ったサブタスク「雇用指示登録申請」「雇用指示承認」を
    // 申請の状況に合わせてすぐ完了にする（2026-09-23。今までは次にサブタスク画面か申請画面を開いたときに合っていた）
    // API: akbsInputForm/syncSubTasks（空の枠はメインタスクの登録（register → createAkbsShell）で面接の行につながっているので、申請が見つかる）
    try {
      await backend.postData('akbsInputForm/syncSubTasks', { employmentId: saved.id })
    } catch (error) {
      console.log('autoEmployTaskSave syncSubTasks error !!!')
      console.log(error)
    }
    return { id: saved.id, requestNo: saved.requestNo }
  }
  return null
}

/**
 * 契約詳細入力画面（AkbsContractForm）から、清掃員の雇い入れメインタスクとサブタスクを登録する
 * 契約詳細を変えると、その契約で働いている清掃員の雇用指示も直す必要があるため、作成者が承認を待たずに作る
 * ・既に雇い入れがあるかは、呼ぶ側（AkbsContractForm.createEmpTasks）が作る直前に清掃員の申請（req_akbs）で確かめる。ここでは確かめない
 *   （同じ清掃員コードで AKBS登録済み・削除以外の申請があれば作らない。メインタスクの登録時にできる空の枠で、この画面から作った分も当たる）
 * ・どの申請から作ったかの控えとして、メインタスクに akbsContractFormId（契約詳細の申請の id）と akbsContractStaffCode（清掃員コード）を持たせる（検索には使わない）
 *   akbsContractFormId は、登録時にできる空の枠（req_akbs.contract_form_id）にも入る（createAkbsShell）。「この画面から作った雇い入れ」の判定はそちらを見る
 * ・種別は画面では「物件追加／契約内容変更／作業終了」の3つだけ選ばせ、雇い入れと同じキー（employmentClass・modifyType）に直して持つ
 *   （サブタスクのセットが RequestPost から登録したときと同じになる）
 * ・件名は RequestPost の getTitle2 と同じ作り
 * ・今回の変更内容は、バックが清掃員の申請（req_akbs）の contract_notes（見るだけのメモ）へ書く（API: akbsContractForm/syncEmploymentNotes）。メインタスクには何も書かない
 * ・メインタスク登録のチャット通知は送らない（ユーザー指示）
 * @param {*} context
 * @param {*} data { formId, staffCode, staffName, kind: 'add'｜'change'｜'end', department: { departmentId, name }, staff: { userId, userName } か null, limitDate }
 * @returns { id, requestNo } 失敗したら false
 */
export async function registerEmploymentFromContract(context, data) {
  try {
    const key = { akbsContractFormId: String(data.formId), akbsContractStaffCode: String(data.staffCode) }

    const user = context.$store.getters.user
    const rp = create()
    rp.category = ['雇い入れ（清掃員）']
    rp.category2 = ['社内']
    // RequestPost で開いたとき、新しい雇い入れの画面（EmploymentDCNewComponents）で出す（RequestPost.vue の新規登録と同じ目印）
    rp.dcNew2 = true

    // 種別（サブタスクのセットと件名が決まる）
    let detail = ''
    if (data.kind == 'add') {
      rp.employmentClass = ['物件追加']
    } else {
      rp.employmentClass = ['契約変更']
      rp.modifyType = data.kind == 'end' ? 2 : 1
      rp.changeOnlyPrice = false
      detail = data.kind == 'end' ? '（作業終了）' : '（契約内容変更）'
    }

    rp.employmentName = data.staffName || ''
    rp.employmentStaffNumber = data.staffCode
    rp.inquiry_title = (rp.employmentClass[0] + '　' + rp.employmentName + detail).trim()

    // 依頼先・依頼主・期限
    rp.toDepartment = data.department.name
    rp.toDepartmentId = data.department.departmentId
    rp.toStaffId = data.staff ? data.staff.userId : ''
    rp.toStaffName = data.staff ? data.staff.userName : '未定'
    rp.byUserId = user.id
    rp.byUser = user.user_name
    rp.limitDate = data.limitDate
    rp.kubunLimit = 2

    Object.assign(rp, key)

    // メインタスク登録（register の中で AKBS の申請の空の枠も作られる）
    const saved = await register(context, rp)
    if (!saved || !saved.id) {
      return false
    }
    rp._id = saved.id
    rp.requestNo = saved.requestNo

    // サブタスク登録（RequestPost で新規登録したときと同じ）
    const tar = taskRequestManager.getRequireSubTaskKeyWord(rp)
    if (tar) {
      const subTask = await taskRequestManager.initSubTask(context, rp, '雇い入れ', tar)
      for (const s of subTask) {
        await taskRequestManager.register(context, s)
      }
    }

    return { id: saved.id, requestNo: saved.requestNo }
  } catch (error) {
    console.log('requestPostManager.registerEmploymentFromContract error !!!')
    console.log(error)
    return false
  }
}

/**
 * 面接データを雇い入れに反映
 * @param {*} user ユーザー情報
 * @param {*} data 面接タスクデータ
 * @param {*} mainTask メインタスクデータ（手動の場合）
 * @returns
 */
export function setEmployFromInterview(user, data, mainTask) {
  let rp = create()

  // メインタスクで手動で雇い入れ作成
  if (mainTask) {
    rp = mainTask

  // 面接タスクから自動で雇い入れ生成
  } else {
    // 社員
    if (data && data.interviewsRegularStaff) {
      rp.employmentRegularStaff = true
      rp.category = ['雇い入れ（社員）']
    } else {
      rp.category = ['雇い入れ（清掃員）']
    }
  }

  // 期限を10日後にする
  rp.limitDate = moment().add(10, 'days').format('YYYY-MM-DD')
  rp.kubunLimit = 1

  // 依頼先部署を人事総務経理、担当者は未定でセット
  rp.toDepartment = '人事総務経理'
  rp.toDepartmentId = 'd1449'
  rp.toStaffId = '6419'
  rp.toStaffName = '未定'

  // 依頼主はログインユーザー
  rp.byUserId = user.id
  rp.byUser = user.user_name

  // 社内
  rp.category2 = ['社内']

  //選択した面接者のデータを反映
  if (data) {
    // 面接選択した
    rp.notNewEnter = false

    // 新規登録の際に使用する面接のID
    rp.interviewsId = data._id

    // AKBS の申請が登録済みか（面接だけの申請を承認して AKBS に登録すると、面接タスクに立つ。雇い入れにも引き継ぐ。2026-09-23）
    rp.savedAkbs = !!data.savedAkbs

    // 面接データを引き継ぐ
    // お問い合わせカテゴリー
    rp.category2 = data.category2
    // タイトル
    rp.inquiry_title = data.inquiry_title
    // 対応内容
    rp.reason_note = data.reason_note
    // 氏名
    rp.employmentName = data.interviewsName

    // 社員の場合
    if (rp.employmentRegularStaff) {
      // 種別を新規入社にする
      rp.employmentClass = ['社員入社']
      // カナ
      rp.employmentKana = data.interviewsKana
      // 年齢
      rp.employmentAge = data.interviewsAge
      // 週休
      rp.employmentWeekly = data.interviewsWeekly || []
      // 部署
      rp.employmentDepartmentId = data.interviewsDepartmentId || []
      // 新卒フラグ
      rp.employmentNewGrad = data.newGrad || false
      // メアド
      rp.employmentMail = data.interviewsMail || ''
      // ドメイン
      rp.employmentMailDomain = data.mailDomain || ''

    // DCの場合
    } else {
      // 期限を21日後にする
      rp.limitDate = moment().add(21, 'days').format('YYYY-MM-DD')
      rp.kubunLimit = 2
      // 種別を新規入社にする
      rp.employmentClass = ['新規入社']
      // 新入社員
      rp.employmentNewGrad = false
      // 新旧
      rp.dcNew2 = true

      // 得意先
      // rp.clientName = data.clientName
      // 得意先コード
      // rp.clientCode = data.clientCode
      // 得意先住所
      // rp.clientAddress1 = data.clientAddress1
      // rp.clientAddress2 = data.clientAddress2

      // 物件名（裏で持っている選択以外変更不可）
      // rp.targetSite = data.targetSite
      // 物件名（画面表示）
      rp.employmentBuildingName = data.interviewsAppliedWorkLocationAddress
      // 物件コード
      // rp.employmentSiteCode = data.interviewsSiteCode
      // 物件住所
      // rp.employmentSiteAddress = data.interviewsSiteAddress

      // 入社日
      rp.employmentHireDate = data.interviewsHireDate
      // 誕生日
      // rp.employmentBirthDay = data.interviewsBirthDay
      // 性別
      rp.employmentSex = data.interviewsSex
      // 〒
      // rp.employmentPostCode = data.interviewsPostCode
      // 住所
      // rp.employmentAddress1 = data.interviewsAddress1
      // rp.employmentAddress2 = data.interviewsAddress2
      // TEL
      // rp.employmentTel =  data.interviewsTel
      // rp.employmentMobile = data.interviewsMobile

      // 書類
      rp.employmentMaterial = utils.clone(data.interviewsMaterial)
      // 履歴書をコピーする
      rp.employmentDocument_display_file_name = data.interviewsDocument_display_file_name
      rp.employmentDocument = utils.clone(data.interviewsDocument)
      rp['employmentDocument_file_content'] = data.interviewsDocument.url
      rp.employmentDocument_file_name = data.interviewsDocument_display_file_name

      rp.employmentMedium = getInterviewsValue(data.interviewsMedium, rp.employmentMedium)
      rp.employmentRemarks = data.employmentRemarks

      // 新しい面接から新しい雇入れに反映
      // if (data.dcNew) {
      //   // エリア
      //   rp.area = data.area
      //   // 時給
      //   rp.hourlyWage = data.hourlyWage
      //   // 家族
      //   rp.familyMembers = data.familyMembers
      //   // 緊急連絡先
      //   rp.emergency = data.emergency
      //   // 作業開始日
      //   rp.startDateWork = data.startDateWork
      //   // 勤務情報
      //   rp.appliedWork = data.appliedWork
      //   // rp.siteShort = data.siteShort
      //   // rp.contract = data.contract
      //   rp.contractCode = data.contractCode
      //   // 得意先
      //   rp.clientLists = [{ clientName: data.clientName, clientCode: data.clientCode, clientFax: (data.clientFax || '') }]

      // // 古い面接から古い雇入れに反映
      // } else {
      //   // エリア
      //   rp.employmentArea = data.interviewsArea
      //   // 時給
      //   rp.employmentHourlyWage = data.interviewsHourlyWage

      //   rp.employmentEmergencyContactKana = data.interviewsEmergencyContactKana
      //   rp.employmentEmergencyContact = data.interviewsEmergencyContact
      //   rp.employmentEmergencyAddress = data.interviewsEmergencyAddress
      //   rp.employmentEmergencyPhoneNumber = data.interviewsEmergencyPhoneNumber
      //   rp.employmentEmergencyRelationship = data.interviewsEmergencyRelationship
        
      //   rp.employmentWorkTask = getInterviewsValue(data.interviewsWorkTask, rp.employmentWorkTask)
      //   rp.employmentHolidayType = getInterviewsValue(data.interviewsHolidayType, rp.employmentHolidayType)
      //   rp.employmentTrashRemoval = getInterviewsValue(data.interviewsTrashRemoval, rp.employmentTrashRemoval)

      //   rp.employmentTrainType = getInterviewsValue(data.interviewsTrainType, rp.employmentTrainType)
      //   rp.employmentTrainExpenses = getInterviewsValue(data.interviewsTrainExpenses, rp.employmentTrainExpenses)
      //   rp.employmentBusType = getInterviewsValue(data.interviewsBusType, rp.employmentBusType)
      //   rp.employmentBusExpenses = getInterviewsValue(data.interviewsBusExpenses, rp.employmentBusExpenses)
      //   rp.employmentParkingType = getInterviewsValue(data.interviewsParkingType, rp.employmentParkingType)
      //   rp.employmentParkingExpenses = getInterviewsValue(data.interviewsParkingExpenses, rp.employmentParkingExpenses)
      //   // 勤務情報
      //   rp.employmentAppliedWork = utils.clone(data.interviewsAppliedWork)
      //   rp.clientFax = data.clientFax || ''
      // }
    }
  } else {
    rp.notNewEnter = true

    // 社員の場合
    if (rp.employmentRegularStaff) {
      rp.employmentClass = ['社員退職']
    }
  }

  return rp
}

/**
 * データがあれば、面接内容を取得
 * @param inter 面接対象データ
 * @param emp 雇い入れプロパティ
 */
function getInterviewsValue(inter, emp) {
  if (inter && inter.length) {
    return inter
  }
  // 配列の場合
  if (Array.isArray(emp)) {
    return []
  // 文字列の場合
  } else {
    return ''
  }
}

/**
 * カレンダー取得
 * @param {*} context
 * @param {*} filter 検索
 * @param {*} userName ログインユーザー名（カナなし）
 * @param {*} userId ユーザーID
 * @param {*} group4 ユーザーグループが4以上か
 * @param {*} admin 管理者権限
 * @param {*} regularStaffAuth 社員面接権限
 * @param {*} manager 人事部
 * @param {*} mainDepartment 主要部署
 * @param {*} dualPositionNames 兼任部署配列
 * @param {*} dualPositionIds 兼任部署ID配列
 * @returns
 */
export async function getTaskCalendar(
  context,
  filter,
  userName,
  userId,
  group4,
  admin,
  regularStaffAuth,
  manager,
  mainDepartment,
  dualPositionNames,
  dualPositionIds
) {
  // 社員雇い入れ表示条件（管理者or人事orG4以上）
  const isEmployment = (admin || manager || group4)
  // 管理者権限OR人事総務経理所属or権限 ➡ 面接関連表示
  const YESregular = (admin || manager || regularStaffAuth)
  // 部署検索に使用する部署in句用
  const depArr = [filter.department, filter.dentatsu]


  // メインのtype
  const mainType = []

  if (filter.main || filter.empDC || (filter.empReg && isEmployment)) {
    mainType.push(REQUESTPOST_TASKS_TYPE)
  }
  if (filter.order) {
    mainType.push(ORDER_TASKS_TYPE)
  }

  // サブのtype
  const subType = []
  const lookupMain = []

  if (filter.sub) {
    if (filter.main || filter.empDC || (filter.empReg && isEmployment)) {
      subType.push(('task_request'))
      lookupMain.push(REQUESTPOST_TASKS_TYPE)
    }
    if (filter.order) {
      subType.push(('task_request_order'))
      lookupMain.push(ORDER_TASKS_TYPE)
    }
  }

  // 検索期間
  let start = filter.start
  let end = filter.end
  if (filter.title === 1) {
    start = moment(filter.month).startOf('month').format('YYYY-MM-DD')
    end = moment(filter.month).endOf('month').format('YYYY-MM-DD')
  }

  let aggregate = [
    // メイン・サブ共通の条件
    {
      $match: {
        status: 'open',
        limitDate: { $gte: start, $lte: end },
        type: { $in: mainType.concat(subType) }
      }
    }
  ]

  const nameSpaceAnd = spaceAndSearch(userName)

  // 同時集計
  const $facet = {}

  // ********メインタスクの条件を生成********
  if (filter.main || filter.empDC || (filter.empReg && isEmployment) || filter.order) {
    const $match = {}
    $match.$or = []

    $match.type = { $in: mainType }

    // 自分のタスクのみ
    if (filter.title === 1) {
      $match.toStaffName = { $regex: nameSpaceAnd }
    // 部署検索
    } else {
      $match.toDepartment = { $in: depArr }
    }

    // メインがON
    if (filter.main) {
      const $and = []

      // 管理者権限OR人事総務経理所属or権限
      if (YESregular) {
        // 管理者の場合、非公開もOK
        if (admin) {
          // 除外カテゴリー
          $and.push({ category: { '$nin': ['雇い入れ', '雇い入れ（清掃員）', '雇い入れ（社員）'] } })
        } else {
          // 除外カテゴリー
          $and.push({ category: { '$nin': ['非公開依頼', '雇い入れ', '雇い入れ（清掃員）', '雇い入れ（社員）'] } })
        }

      // 管理者でも人事総務経理でも権限もない場合
      } else {
        // 除外カテゴリー
        $and.push({ category: { '$nin': ['非公開依頼', '雇い入れ', '雇い入れ（清掃員）', '雇い入れ（社員）'] } })

        // 社員面接以外
        $and.push({ interviewsRegularStaff: { $ne: true } })
      }
      $match.$or.push({ $and })

      // 管理者以外
      // 非公開依頼
      if (!admin) {
        const $and2 = []
        // 非公開依頼はユーザーが担当者OR依頼主
        $and2.push({ category: ['非公開依頼'] })
        const $or = []
        // 担当者IDがユーザーと同じ
        $or.push({ toStaffId: userId })
        // もしくは依頼主IDがユーザーと同じ
        $or.push({ byUserId: userId })
        // もしくは担当が未定の場合、同じ所属部署ならOK
        $or.push({'$and': [{ toStaffName: '未定' }, { toDepartment: mainDepartment }]})
        $and2.push({ $or })
        $match.$or.push({ $and: $and2 })
      }

      // 管理者でも人事総務経理でもない場合
      // 社員面接
      if (!YESregular) {
        const $and2 = []
        $and2.push({ interviewsRegularStaff: true })
        const $or = []
        // 担当者がユーザーと同じ
        $or.push({ toStaffName: { $regex: nameSpaceAnd } })
        $or.push({ toStaffId: userId })
        // もしくは依頼主がユーザーと同じ
        $or.push({ byUser: { $regex: nameSpaceAnd } })
        $or.push({ byUserId: userId })

        // 社員面接権限あり
        if (regularStaffAuth && dualPositionNames && dualPositionNames.length) {
          // 同じ部署であればOk
          $or.push({ toDepartment: { $in: dualPositionNames } })
        }
        $and2.push({ $or })
        $match.$or.push({ $and: $and2 })
      }
    }

    // DC雇い入れ
    if (filter.empDC) {
      const $and = []
      // 対象カテゴリー
      $and.push({ category: { '$in': ['雇い入れ', '雇い入れ（清掃員）'] } })
      // 社員ではない
      $and.push({ employmentRegularStaff: { $ne: true } })
      $match.$or.push({ $and })
    }

    // 社員雇い入れON、トグル表示権限あり
    if (filter.empReg && isEmployment) {
      const $and = []
      // 対象カテゴリー
      $and.push({ category: { '$in': ['雇い入れ', '雇い入れ（社員）'] } })
      // 社員である
      $and.push({ employmentRegularStaff: true })

      // 管理者でも、人事でもない場合
      if (!admin && !manager) {
        $and.push({
          '$or': [
            // 同じ部署のみOK（入社の時の項目）
            { employmentDepartmentId: { '$in': dualPositionIds } },
            // 依頼主が自分
            { byUser: { $regex: nameSpaceAnd } },
            { byUserId: userId },
            // 担当が自分
            { toStaffName: { $regex: nameSpaceAnd } },
            { toStaffId: userId },
            // 担当未定の場合、同じ部署OK
            {'$and': [
              { toStaffName: '未定' },
              { toDepartment: mainDepartment }
            ]}
          ]
        })
      }
      $match.$or.push({ $and })
    }

    $facet.main = [
      { $match },
      { $sort: { type: 1, requestNo: 1 } },
      {
        $project: {
          _id: { $toString: '$_id' },
          date: '$limitDate',
          mainLimit: '$limitDate',
          main: '$inquiry_title',
          category: '$category',
          staff: '$toStaffName',
          type: 1,
          requestNo: 1,
          employmentRegularStaff: 1,
          subs: []
        }
      }
    ]
  } else {
    $facet.main = [
      { $match: { _id: null } } // 絶対ヒットしない
    ]
  }

  // ********サブタスクの条件を生成********
  if (filter.sub) {
    // サブタスク条件
    const $match = {}

    $match.type = { $in: subType }

    // 自分のタスクのみ
    if (filter.title === 1) {
      $match.toStaffName = { $regex: nameSpaceAnd }
    // 部署検索
    } else {
      $match.departmentName = { $in: depArr }
    }

    // 紐づく親を取得
    const $lookup = {
      from: "Tasks",
      let: { requestPostId: '$requestPostId', orderId: '$orderId' },
      pipeline: [
        {
          $match: {
            $expr: {
              $or: [
                {
                  $eq: [
                    { $toString: '$_id' },
                    '$$requestPostId'
                  ]
                },
                {
                  $eq: [
                    { $toString: '$_id' },
                    '$$orderId'
                  ]
                }
              ]
            },
            status: 'open',
            type: { $in: lookupMain }
          }
        }
      ],
      as: 'main'
    }

    // カテゴリー別の取得条件
    const $matchCategory = { $expr: {} }
    const $orCategory = []

    if (filter.main) {
      // 管理者権限OR人事総務経理所属or権限
      if (YESregular) {
        // 管理者の場合、非公開もOK
        if (admin) {
          // 除外カテゴリー
          $orCategory.push({
            $and: [
              { $not: { $in: ['雇い入れ', '$main.category'] } },
              { $not: { $in: ['雇い入れ（清掃員）', '$main.category'] } },
              { $not: { $in: ['雇い入れ（社員）', '$main.category'] } }
            ]
          })
        } else {
          // 除外カテゴリー
          $orCategory.push({
            $and: [
              { $not: { $in: ['非公開依頼', '$main.category'] } },
              { $not: { $in: ['雇い入れ', '$main.category'] } },
              { $not: { $in: ['雇い入れ（清掃員）', '$main.category'] } },
              { $not: { $in: ['雇い入れ（社員）', '$main.category'] } }
            ]
          })
        }

      // 管理者でも人事総務経理でも権限もない場合
      } else {
        const $and = [
          { $not: { $in: ['非公開依頼', '$main.category'] } },
          { $not: { $in: ['雇い入れ', '$main.category'] } },
          { $not: { $in: ['雇い入れ（清掃員）', '$main.category'] } },
          { $not: { $in: ['雇い入れ（社員）', '$main.category'] } }
        ]

        // 社員面接以外
        $and.push({ $ne: ['$main.interviewsRegularStaff', true] })

        $orCategory.push({ $and })
      }


      // 管理者以外
      if (!admin) {
        // 非公開
        $orCategory.push({
          $and: [
            { $in: ['非公開依頼', '$main.category'] },
            { $or: [
              // 担当者IDがユーザーと同じ
              { $eq: ['$toStaffId', userId] },
              // もしくは依頼主IDがユーザーと同じ
              { $eq: ['$byUserId', userId] },
              // もしくは担当が未定の場合、同じ所属部署ならOK
              { $and: [
                { $eq: ['$toStaffName', '未定'] },
                { $eq: ['$departmentName', mainDepartment] }
              ]}
            ]}
          ]
        })
      }

      // 管理者でも人事総務経理でもない場合
      if (!YESregular) {
        // 社員面接
        const $and = [
          { $eq: ['$main.interviewsRegularStaff', true] }
        ]

        const $or = [
          // 担当者がユーザーと同じ
          { $regexMatch: { input: '$toStaffName', regex: nameSpaceAnd } },
          // もしくは依頼主がユーザーと同じ
          { $regexMatch: { input: '$byUser', regex: nameSpaceAnd } }
        ]

        // 社員面接権限あり
        if (regularStaffAuth && dualPositionNames && dualPositionNames.length) {
          // 同じ部署であればOk
          $or.push({
            $in: [
              { $arrayElemAt: ['$departmentName', 0] },
              dualPositionNames
            ]
          })
        }

        $and.push({ $or })
        $orCategory.push({ $and })
      }
    }

    // DC雇い入れ
    if (filter.empDC) {
      const $and = [
        { $in: [
            { $arrayElemAt: ['$main.category', 0] },
            ['雇い入れ', '雇い入れ（清掃員）']
        ]},
        { $ne: ['$main.employmentRegularStaff', true] }
      ]
      $orCategory.push({ $and })
    }

    // 社員雇い入れON、トグル表示権限あり
    if (filter.empReg && isEmployment) {
      const $and = [
        { $eq: ['$main.employmentRegularStaff', true] },
        { $in: [
            { $arrayElemAt: ['$main.category', 0] },
            ['雇い入れ', '雇い入れ（社員）']
        ]}
      ]

      // 管理者でも、人事でもない場合
      if (!admin && !manager) {
        $and.push({
          '$or': [
            // 同じ部署のみOK（入社の時の項目）
            { $in: [
                { $arrayElemAt: ['$main.employmentDepartmentId', 0] },
                dualPositionIds
            ]},
            // 依頼主が自分
            { $regexMatch: { input: '$byUser', regex: nameSpaceAnd } },
            { $eq: ['$byUserId', userId] },
            // 担当が自分
            { $regexMatch: { input: '$toStaffName', regex: nameSpaceAnd } },
            { $eq: ['$toStaffId', userId] },
            // 担当未定の場合、同じ部署OK
            {
              $and: [
                { $eq: ['$toStaffName', '未定'] },
                { $eq: ['$departmentName', mainDepartment] }
              ]
            }
          ]
        })
      }

      $orCategory.push({ $and })
    }

    $matchCategory.$expr = { $or: $orCategory }

    $facet.subs = [
      { $match },
      { $lookup },
      { $unwind: '$main' }, // 配列をオブジェクトに変更&メインがなければサブも消える
      { $match: $matchCategory }, // メインのカテゴリによってサブの条件が変わる
      {
        $project: {
          parentId: { $toString: '$main._id' },
          date: '$limitDate',
          main: '$main.inquiry_title',
          type: '$main.type',
          requestNo: '$main.requestNo',
          mainLimit: '$main.limitDate',
          category: '$main.category',
          interviewsRegularStaff: '$main.interviewsRegularStaff',
          employmentRegularStaff: '$main.employmentRegularStaff',
          staff: '$toStaffName',
          sub: '$requestTask',
          displayOrder: '$displayOrder'
        }
      },
      { $sort: { parentId: 1, 'displayOrder': 1 } },
      // 同じdate、メイン、担当者でまとめる
      {
        $group: {
          _id: {
            date: '$date',
            parentId: '$parentId',
            staff: '$staff'
          },
          main: { $first: '$main' },
          type: { $first: '$type' },
          requestNo: { $first: '$requestNo' },
          mainLimit: { $first: '$mainLimit' },
          category: { $first: '$category' },
          interviewsRegularStaff: { $first: '$interviewsRegularStaff' },
          employmentRegularStaff: { $first: '$employmentRegularStaff' },
          subs: { $push: '$sub' }
        }
      },
      { $sort: { 'requestNo': 1 } },
      {
        $match: {
          'subs.0': { $exists: true }
        }
      },
      {
        $project: {
          _id: '$_id.parentId',
          date: '$_id.date',
          staff: '$_id.staff',
          main: 1,
          type: 1,
          requestNo: 1,
          mainLimit: 1,
          category: 1,
          interviewsRegularStaff: 1,
          employmentRegularStaff: 1,
          subs: 1
        }
      }
    ]
  } else {
    $facet.subs = [
      { $match: { _id: null } } // 絶対ヒットしない
    ]
  }

  aggregate.push({ $facet })

  // ********メインとサブを結合********
  const $project = {
    all: {
      $concatArrays: [
        { $ifNull: ['$main', []] },
        { $ifNull: ['$subs', []] }
      ]
    }
  }
  aggregate.push({ $project })

  aggregate.push({ $unwind: '$all' }) // allの中の配列をバラシて1件ずつのオブジェクトにするall:[...]→[all:{...},all:{...}]
  aggregate.push({ $replaceRoot: { newRoot: '$all' } }) // all消す[all:{...},all:{...}]→[{...},{...}]
  aggregate.push({ $sort: { date: 1, staff: 1 } })

  try {
    const res = await context.$pigeon.aggregateTasks(aggregate) || []
    // console.log(res)
    return res

  } catch (error) {
    console.log('カレンダー error !!!')
    console.log(error)
    alert('エラーが発生しました。\r\n' + error)
    return []
  }
}